import {
  CHECK_ICON_PATH,
  CHECK_WHITE_ICON_PATH,
  EXCLAMATION_WHITE_ICON_PATH,
} from 'constants/images.constants';
import { PaymentStatusView } from 'enums';

export const SQ_ICON_CONFIG: Record<
  PaymentStatusView,
  { iconPath: string; iconBg: string }
> = {
  [PaymentStatusView.Success]: {
    iconPath: CHECK_ICON_PATH,
    iconBg: 'tw-bg-success',
  },
  [PaymentStatusView.Cancel]: {
    iconPath: EXCLAMATION_WHITE_ICON_PATH,
    iconBg: 'tw-bg-[#DE2960]',
  },
  [PaymentStatusView.CustomerConfirmTimeout]: {
    iconPath: EXCLAMATION_WHITE_ICON_PATH,
    iconBg: 'tw-bg-[#DE2960]',
  },
  [PaymentStatusView.NoRequisites]: {
    iconPath: EXCLAMATION_WHITE_ICON_PATH,
    iconBg: 'tw-bg-[#DE2960]',
  },
  [PaymentStatusView.AssignAttempts]: {
    iconPath: EXCLAMATION_WHITE_ICON_PATH,
    iconBg: 'tw-bg-[#DE2960]',
  },
  [PaymentStatusView.Dispute]: {
    iconPath: EXCLAMATION_WHITE_ICON_PATH,
    iconBg: 'tw-bg-[#DE2960]',
  },
  [PaymentStatusView.Processing]: {
    iconPath: CHECK_WHITE_ICON_PATH,
    iconBg: 'tw-bg-[#0162FF]',
  },
};
